import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

const ConfirmModal = ({ isOpen, toggle, onConfirm, title = "Are you sure?", message, isLoading = false }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {message}
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' outline onClick={toggle} disabled={isLoading}>
          Cancel
        </Button>
        <Button color='danger' onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Please wait...' : 'Confirm'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmModal